import store from '@state/store'

import Role from './roles.js'

export default [
  {
    path: '/',
    name: 'login',
    component: () => lazyLoadView(import('@views/login.vue')),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login.vue')),
    meta: {
      layout: 'auth-layout',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      authRequired: true,
    },
    component: () => lazyLoadView(import('@views/home.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/paxsummary/:flightId',
    name: 'paxbyflight',
    meta: {
      authRequired: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Flights', route: '/flights' },
        { title: 'Pax Summary', route: 'paxsummary' },
      ],
    },
    component: () => lazyLoadView(import('@views/paxByFlight.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/seatmap/:flightId',
    name: 'seatmap',
    meta: {
      authRequired: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Flights', route: '/flights' },
        { title: 'SeatMap', route: 'seatmap' },
      ],
    },
    component: () => lazyLoadView(import('@views/seatmap.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/seatmap2/:flightId',
    name: 'seatmap2',
    meta: {
      authRequired: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Flights', route: '/flights' },
        { title: 'SeatMap2', route: 'seatmap' },
      ],
    },
    component: () => lazyLoadView(import('@views/seatmap2.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/flights',
    name: 'flights',
    meta: {
      authRequired: true,
      authRoles: [Role.Flights],
      keepAlive: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Flights', route: 'flights' },
      ],
    },
    component: () => import('@views/flightsGrid.vue'),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/flightsboard',
    name: 'flightsboard',
    meta: {
      authRequired: true,
      keepAlive: false,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Flights', route: 'flightsboard' },
        { title: 'Flights Board', route: 'flightsboard' },
      ],
    },
    component: () => lazyLoadView(import('@views/flightBoard.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/paxtotals',
    name: 'paxTotals',
    meta: {
      authRequired: true,
      keepAlive: false,
      menu: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Pax Totals', route: '/paxTotals' },
      ],
    },
    component: () => lazyLoadView(import('@views/reportPaxTotals.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'nationality',
        name: 'paxTotalsByNat',
        meta: {
          authRequired: true,
          keepAlive: false,
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Pax Totals', route: '/paxTotals' },
            { title: 'Passenger Totals by Nationality', route: 'paxTotals' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportPaxTotalsNat.vue')),
      },
      {
        path: 'destinations',
        name: 'paxTotalsByDest',
        meta: {
          authRequired: true,
          keepAlive: false,
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Pax Totals', route: '/paxTotals' },
            { title: 'Passenger Totals by Destination', route: 'xxx' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportPaxTotalsDest.vue')),
      },
      {
        path: 'touroperator',
        name: 'paxTotalsByTour',
        meta: {
          authRequired: true,
          keepAlive: false,
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Pax Totals', route: '/paxTotals' },
            { title: 'Passenger Totals by Tour Operator', route: 'xxx' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportPaxTotalsTour.vue')),
      },
    ],
  },
  {
    path: '/systemusage',
    name: 'systemusage',
    meta: {
      authRequired: true,
      keepAlive: false,
      menu: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'System Usage', route: 'systemusage' },
      ],
    },
    component: () => lazyLoadView(import('@views/reportUsageBase.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'WeeklyProfile',
        name: 'usageWeeklyProfile',
        menu: false,
        meta: {
          authRequired: true,
          keepAlive: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'System Usage', route: '/systemusage' },
            { title: 'Weekly Profile', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportWeekProfile.vue')),
      },
      {
        path: 'UsageReport',
        name: 'usageReport',
        meta: {
          authRequired: true,
          keepAlive: false,
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'System Usage', route: '/systemusage' },
            { title: 'Usage Report', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportUsage.vue')),
      },
      {
        path: 'CheckinReport',
        name: 'usageCheckin',
        menu: false,
        meta: {
          authRequired: true,
          keepAlive: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'System Usage', route: '/systemusage' },
            { title: 'Checkin Report', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/reportCheckin.vue')),
      },
    ],
  },

  {
    path: '/kiosks',
    name: 'kiosks',
    meta: {
      authRequired: true,
      keepAlive: true,
      authRoles: [Role.Kiosk],
      menu: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Kiosks', route: '/kiosks' },
      ],
    },
    component: () => lazyLoadView(import('@views/kiosk.vue')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'kioskDatabase',
        name: 'kioskDatabase',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/kioskDatabase' },
            { title: 'Kiosk Database', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/kiosks.vue')),
      },
      {
        path: 'kioskAirlines',
        name: 'kioskAirlines',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/kioskDatabase' },
            { title: 'Airline', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/Airlines.vue')),
      },
      {
        path: 'kioskAirlineMenus',
        name: 'kioskAirlineMenus',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/kioskDatabase' },
            { title: 'Airline Menus', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/AirlineMenus.vue')),
      },
      {
        path: 'kiosksThemeGenerator',
        name: 'kiosksThemeGenerator',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/Kiosks' },
            { title: 'Kiosk Theme Customiser', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/kioskThemeGenerator.vue')),
      },
      {
        path: 'kioskAirlineGroups',
        name: 'kioskAirlineGroups',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/Kiosks' },
            { title: 'Kiosk Theme Customiser', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/kioskThemeGenerator.vue')),
      },
      {
        path: 'kioskLocations',
        name: 'kioskLocations',
        meta: {
          authRequired: true,
          keepAlive: false,
          authRoles: [Role.Kiosk],
          menu: false,
          breadcrumb: [
            { title: 'Home', route: '/home' },
            { title: 'Kiosks', route: '/Kiosks' },
            { title: 'Kiosk Theme Customiser', route: '' },
          ],
        },
        component: () => lazyLoadView(import('@views/kioskThemeGenerator.vue')),
      },
    ],
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile.vue')),
    meta: {
      authRequired: true,
      breadcrumb: [
        { title: 'Home', route: '/home' },
        { title: 'Profile', route: '/profile' },
      ],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:username',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile.vue')),
    meta: {
      authRequired: true,
      // HACK: In order to share data between the `beforeResolve` hook
      // and the `props` function, we must create an object for temporary
      // data only used during route resolution.
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to `meta.tmp`, so that it can
            // be provided as a prop.
            routeTo.meta.tmp.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.meta.tmp.user }),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'login' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 500,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 50000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
